import helper from './helper'

export default {
  get() {
    return helper.get(`/users/get-full`)
  },
  getByEmail(email) {
    return helper.get('/users/get-by-email/' + email)
  },
  getAdmins() {
    return helper.get(`/users/get-admins`)
  },
  updateRole(id, role) {
    return helper.put(`/users/update-role/${id}`, { role: role })
  },
  updateEvents(id, events) {
    return helper.put(`/users/update-events/${id}`, { events: events })
  }
}
